import { action, computed } from "mobx";

import { FieldType, ViewModelBase } from "@shoothill/core";
import { StoresInstance } from "../../Stores";
import { PaymentModel } from "Globals/Models/Domain/Payment/PaymentModel";
import { AppUrls } from "AppUrls";

export default class PaymentViewModel extends ViewModelBase<PaymentModel> {
    constructor() {
        super(new PaymentModel());
    }

    @computed
    public get allPayBaseUrl(): string {
        return StoresInstance.Domain.AccountStore.AllPayBaseUrl;
    }

    @computed
    public get customerReference(): string {
        return StoresInstance.Domain.AccountStore.FirstName + " " + StoresInstance.Domain.AccountStore.LastName;
    }

    @computed
    public get allPayToken(): string {
        return StoresInstance.Domain.ApplicationFormStatusStore.getAllPayToken;
    }

    @action
    public handleGetPaymentToken(): void {
        this.getPaymentToken();
    }

    @action
    public async getPaymentToken(): Promise<void> {
        this.setIsLoading(true);
        try {
            await this.getPaymentTokenDTO();
        } catch (exception) {
            // Set server validation error messages.
        } finally {
            // Finally
            this.setIsLoading(false);
        }
    }

    @action
    private async getPaymentTokenDTO(): Promise<void> {
        const apiResult = await this.Post<string>(AppUrls.Server.ApplicationForm.Upsert.GetAllPayToken);
        if (apiResult.wasSuccessful) {
            console.log("Decrypted AllKeys token", apiResult.payload);
            StoresInstance.Domain.ApplicationFormStatusStore.setAllPayToken(apiResult.payload);
        } else {
            console.error("Decrypted AllKeys token", apiResult.errors);
            StoresInstance.Domain.ApplicationFormStatusStore.setAllPayToken("");
        }
    }

    public async isFieldValid(fieldName: keyof FieldType<PaymentModel>, value: any): Promise<boolean> {
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
